"use strict";
/*
 * Created on 13.02.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WindowOverviewDTO_1 = require("../model/WindowOverviewDTO");

var WindowOverviewFlag_1 = require("../model/WindowOverviewFlag");

var WindowOverviewDTOConverter_1 = require("./WindowOverviewDTOConverter");
/**
 * Default implementation of WindowOverviewDTOConverter.
 * @author Tomáš Leity
 */


var WindowOverviewDTOConverterImpl =
/*#__PURE__*/
function (_WindowOverviewDTOCon) {
  _inherits(WindowOverviewDTOConverterImpl, _WindowOverviewDTOCon);

  function WindowOverviewDTOConverterImpl() {
    _classCallCheck(this, WindowOverviewDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowOverviewDTOConverterImpl).apply(this, arguments));
  }

  _createClass(WindowOverviewDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new WindowOverviewDTO_1.WindowOverviewDTO(WindowOverviewDTO_1.WindowOverviewDTO.schema.id.valueOf(conversions.documentToClassId(source)), WindowOverviewDTO_1.WindowOverviewDTO.schema.locked.valueOfField(source), WindowOverviewDTO_1.WindowOverviewDTO.schema.lockedForCurrentUser.valueOfField(source), WindowOverviewDTO_1.WindowOverviewDTO.schema.promoDiscount.valueOf(source.promoDiscount === null ? null : conversions.toBigNumber(source.promoDiscount)), WindowOverviewDTO_1.WindowOverviewDTO.schema.promoPrice.valueOf(source.promoPrice === null ? null : conversions.toBigNumber(source.promoPrice)), conversions.asFlagSet(source.flags, WindowOverviewFlag_1.WindowOverviewFlag), WindowOverviewDTO_1.WindowOverviewDTO.schema.lockOwnersName.valueOfField(source), WindowOverviewDTO_1.WindowOverviewDTO.schema.productIds.valueOfField(source), WindowOverviewDTO_1.WindowOverviewDTO.schema.productsNo.valueOfField(source), WindowOverviewDTO_1.WindowOverviewDTO.schema.sales.valueOf(source.sales === null ? null : conversions.toBigNumber(source.sales)), WindowOverviewDTO_1.WindowOverviewDTO.schema.promoVolume.valueOf(source.promoVolume === null ? null : conversions.toBigNumber(source.promoVolume)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        locked: source.locked,
        lockedForCurrentUser: source.lockedForCurrentUser,
        promoDiscount: source.promoDiscount === null ? null : conversions.fromBigNumber(source.promoDiscount),
        promoPrice: source.promoPrice === null ? null : conversions.fromBigNumber(source.promoPrice),
        flags: source.flags.serialize(),
        lockOwnersName: source.lockOwnersName,
        productIds: source.productIds,
        productsNo: source.productsNo,
        sales: source.sales === null ? null : conversions.fromBigNumber(source.sales),
        promoVolume: source.promoVolume === null ? null : conversions.fromBigNumber(source.promoVolume)
      });
      return result;
    }
  }]);

  return WindowOverviewDTOConverterImpl;
}(WindowOverviewDTOConverter_1.WindowOverviewDTOConverter);

exports.WindowOverviewDTOConverterImpl = WindowOverviewDTOConverterImpl;